/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Lms.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckoutSessionResponse,
  EnrollmentResponse,
  LearningPathProgressDto,
  MyLearningPathsResponse,
  PathSeatOrderCheckoutRequest,
  ProblemDetails,
  PublishedLearningPathDto,
  SeatOrderCheckoutResponse
} from '../../../types/api';

import { apiClient } from '../../client/api-client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns a published path's title, short description, learning outcomes, audience, level, picture and total length (the sum of the listed courses' lengths), its navigation mode (0 free, 1 in order), its price (one GBP price in pence for all its courses, null when free) and whether the caller has access to it (always for a free path; for a paid path, only once they are on it), and its published courses in order, each with its delivery type (0 online, 1 instructor-led) and, for an instructor-led course, its next upcoming session (null when it has none). Instructor-led courses are left out while the ilt feature flag is off, and paid ones while the payments flag is off. Open to everyone. Returns 404 for a draft or Restricted path (LMS-154), except that a Restricted path opens to a purchaser an admin granted to buy seats on it (LMS-198) while the payments and seat-orders flags are on, with isRestricted and canBuySeats set and hasAccess false; also 404 for a paid path the caller has no access to while the payments flag is off, and for every path while the learning-paths feature flag is off
 * @summary Get a published learning path
 */
export const learningPathsGetPublished = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<PublishedLearningPathDto>(
      {url: `/api/learning-paths/${id}`, method: 'GET', signal
    },
      );
    }




export const getLearningPathsGetPublishedQueryKey = (id: string,) => {
    return [
    `/api/learning-paths/${id}`
    ] as const;
    }


export const getLearningPathsGetPublishedQueryOptions = <TData = Awaited<ReturnType<typeof learningPathsGetPublished>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetPublished>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLearningPathsGetPublishedQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof learningPathsGetPublished>>> = ({ signal }) => learningPathsGetPublished(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetPublished>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LearningPathsGetPublishedQueryResult = NonNullable<Awaited<ReturnType<typeof learningPathsGetPublished>>>
export type LearningPathsGetPublishedQueryError = void


export function useLearningPathsGetPublished<TData = Awaited<ReturnType<typeof learningPathsGetPublished>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetPublished>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningPathsGetPublished>>,
          TError,
          Awaited<ReturnType<typeof learningPathsGetPublished>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningPathsGetPublished<TData = Awaited<ReturnType<typeof learningPathsGetPublished>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetPublished>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningPathsGetPublished>>,
          TError,
          Awaited<ReturnType<typeof learningPathsGetPublished>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningPathsGetPublished<TData = Awaited<ReturnType<typeof learningPathsGetPublished>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetPublished>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a published learning path
 */

export function useLearningPathsGetPublished<TData = Awaited<ReturnType<typeof learningPathsGetPublished>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetPublished>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLearningPathsGetPublishedQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the published paths the signed-in learner is enrolled on, the most recently joined first, each with its title, picture, the path's status (0 not started, 1 in progress, 2 completed) and how many of the courses they see in it they have completed, and its instructor-led courses, each with its next session (null when it has none upcoming) and the learner's booking status (0 not booked, 1 booked, with the booked session's date, 2 attended). Assigned lists the paths an admin has assigned them that they haven't started (enrolled on), the most recently assigned first; enrolling moves a path from Assigned to the paths they are on. Draft and archived paths are left out
 * @summary List the learner's learning paths
 */
export const learningPathsListMine = (

 signal?: AbortSignal
) => {


      return apiClient<MyLearningPathsResponse>(
      {url: `/api/learning-paths/mine`, method: 'GET', signal
    },
      );
    }




export const getLearningPathsListMineQueryKey = () => {
    return [
    `/api/learning-paths/mine`
    ] as const;
    }


export const getLearningPathsListMineQueryOptions = <TData = Awaited<ReturnType<typeof learningPathsListMine>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsListMine>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLearningPathsListMineQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof learningPathsListMine>>> = ({ signal }) => learningPathsListMine(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof learningPathsListMine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LearningPathsListMineQueryResult = NonNullable<Awaited<ReturnType<typeof learningPathsListMine>>>
export type LearningPathsListMineQueryError = void


export function useLearningPathsListMine<TData = Awaited<ReturnType<typeof learningPathsListMine>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsListMine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningPathsListMine>>,
          TError,
          Awaited<ReturnType<typeof learningPathsListMine>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningPathsListMine<TData = Awaited<ReturnType<typeof learningPathsListMine>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsListMine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningPathsListMine>>,
          TError,
          Awaited<ReturnType<typeof learningPathsListMine>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningPathsListMine<TData = Awaited<ReturnType<typeof learningPathsListMine>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsListMine>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the learner's learning paths
 */

export function useLearningPathsListMine<TData = Awaited<ReturnType<typeof learningPathsListMine>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsListMine>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLearningPathsListMineQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Enrols the signed-in learner on the path. It does not enrol them on its courses: starting a course from the path does that. Enrolling again does nothing. Returns 403 for a paid path the learner has no access to, and 404 for a draft or Restricted path (LMS-154)
 * @summary Enrol on a published learning path
 */
export const learningPathsEnrol = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/learning-paths/${id}/enrolment`, method: 'POST', signal
    },
      );
    }




export const getLearningPathsEnrolMutationKey = () => ['learningPathsEnrol'] as const;

export const getLearningPathsEnrolMutationOptions = <TError = void | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsEnrol>>, TError,LearningPathsEnrolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningPathsEnrol>>, TError,LearningPathsEnrolMutationVariables, TContext> => {

const mutationKey = getLearningPathsEnrolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningPathsEnrol>>, LearningPathsEnrolMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  learningPathsEnrol(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningPathsEnrolMutationResult = NonNullable<Awaited<ReturnType<typeof learningPathsEnrol>>>

    export type LearningPathsEnrolMutationError = void | ProblemDetails
    export type LearningPathsEnrolMutationVariables = {id: string}

    /**
 * @summary Enrol on a published learning path
 */
export const useLearningPathsEnrol = <TError = void | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsEnrol>>, TError,LearningPathsEnrolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningPathsEnrol>>,
        TError,
        LearningPathsEnrolMutationVariables,
        TContext
      > => {
      return useMutation(getLearningPathsEnrolMutationOptions(options), queryClient);
    }
    /**
 * Takes the signed-in learner off the path. They stay enrolled on its courses and keep their progress in them. Unenrolling when not enrolled does nothing. Returns 404 for a draft or Restricted path (LMS-154)
 * @summary Unenrol from a learning path
 */
export const learningPathsUnenrol = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/learning-paths/${id}/enrolment`, method: 'DELETE', signal
    },
      );
    }




export const getLearningPathsUnenrolMutationKey = () => ['learningPathsUnenrol'] as const;

export const getLearningPathsUnenrolMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsUnenrol>>, TError,LearningPathsUnenrolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningPathsUnenrol>>, TError,LearningPathsUnenrolMutationVariables, TContext> => {

const mutationKey = getLearningPathsUnenrolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningPathsUnenrol>>, LearningPathsUnenrolMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  learningPathsUnenrol(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningPathsUnenrolMutationResult = NonNullable<Awaited<ReturnType<typeof learningPathsUnenrol>>>

    export type LearningPathsUnenrolMutationError = void
    export type LearningPathsUnenrolMutationVariables = {id: string}

    /**
 * @summary Unenrol from a learning path
 */
export const useLearningPathsUnenrol = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsUnenrol>>, TError,LearningPathsUnenrolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningPathsUnenrol>>,
        TError,
        LearningPathsUnenrolMutationVariables,
        TContext
      > => {
      return useMutation(getLearningPathsUnenrolMutationOptions(options), queryClient);
    }
    /**
 * Creates a Stripe checkout session for the signed-in learner to buy a paid path, priced from the path's price (the client sends no amount). Paying grants access to the path, and through it to every course in it. Returns 400 for a free path, 404 for a draft or Restricted path (LMS-154), and 409 when the learner already has access to the path. Also 404 while the payments feature flag is off
 * @summary Start learning path purchase checkout
 */
export const learningPathsStartCheckout = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<CheckoutSessionResponse>(
      {url: `/api/learning-paths/${id}/checkout`, method: 'POST', signal
    },
      );
    }




export const getLearningPathsStartCheckoutMutationKey = () => ['learningPathsStartCheckout'] as const;

export const getLearningPathsStartCheckoutMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartCheckout>>, TError,LearningPathsStartCheckoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartCheckout>>, TError,LearningPathsStartCheckoutMutationVariables, TContext> => {

const mutationKey = getLearningPathsStartCheckoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningPathsStartCheckout>>, LearningPathsStartCheckoutMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  learningPathsStartCheckout(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningPathsStartCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof learningPathsStartCheckout>>>

    export type LearningPathsStartCheckoutMutationError = ProblemDetails | void
    export type LearningPathsStartCheckoutMutationVariables = {id: string}

    /**
 * @summary Start learning path purchase checkout
 */
export const useLearningPathsStartCheckout = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartCheckout>>, TError,LearningPathsStartCheckoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningPathsStartCheckout>>,
        TError,
        LearningPathsStartCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getLearningPathsStartCheckoutMutationOptions(options), queryClient);
    }
    /**
 * Lets a purchaser an admin granted a Restricted path (LMS-198) buy a number of seats on it, priced at the path's price per seat (the client sends no amount). A paid path returns a Stripe checkout session; once paid, the seat order on the path is created and appears in My purchases. Seats on a free Restricted path are ordered at £0 straight away, with no Stripe checkout, and the order's id is returned. Buying seats gives the purchaser no access to the path. Paths have no discount codes. Returns 400 for a number of seats outside 1 to 500, and 404 for a path that isn't published and Restricted or that the caller holds no grant on. Also 404 while the payments or seat-orders feature flag is off
 * @summary Start a checkout for several seats on a Restricted learning path
 */
export const learningPathsStartSeatOrderCheckout = (
    id: string,
    pathSeatOrderCheckoutRequest: PathSeatOrderCheckoutRequest,
 signal?: AbortSignal
) => {


      return apiClient<SeatOrderCheckoutResponse>(
      {url: `/api/learning-paths/${id}/seat-checkout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pathSeatOrderCheckoutRequest, signal
    },
      );
    }




export const getLearningPathsStartSeatOrderCheckoutMutationKey = () => ['learningPathsStartSeatOrderCheckout'] as const;

export const getLearningPathsStartSeatOrderCheckoutMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartSeatOrderCheckout>>, TError,LearningPathsStartSeatOrderCheckoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartSeatOrderCheckout>>, TError,LearningPathsStartSeatOrderCheckoutMutationVariables, TContext> => {

const mutationKey = getLearningPathsStartSeatOrderCheckoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningPathsStartSeatOrderCheckout>>, LearningPathsStartSeatOrderCheckoutMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  learningPathsStartSeatOrderCheckout(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningPathsStartSeatOrderCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof learningPathsStartSeatOrderCheckout>>>
    export type LearningPathsStartSeatOrderCheckoutMutationBody = PathSeatOrderCheckoutRequest
    export type LearningPathsStartSeatOrderCheckoutMutationError = ProblemDetails | void
    export type LearningPathsStartSeatOrderCheckoutMutationVariables = {id: string;data: PathSeatOrderCheckoutRequest}

    /**
 * @summary Start a checkout for several seats on a Restricted learning path
 */
export const useLearningPathsStartSeatOrderCheckout = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartSeatOrderCheckout>>, TError,LearningPathsStartSeatOrderCheckoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningPathsStartSeatOrderCheckout>>,
        TError,
        LearningPathsStartSeatOrderCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getLearningPathsStartSeatOrderCheckoutMutationOptions(options), queryClient);
    }
    /**
 * Returns whether the signed-in learner is enrolled, how many of the path's courses they have completed (any version of a course counts, including ones completed before they joined) and each course's status: 0 not started, 1 in progress, 2 completed. In an in-order path each course also says whether it is locked and which course to complete first; a course already started is never locked. A course is in progress once the learner has opened it or, for an instructor-led course, holds a booking on one of its sessions whose attendance is not yet marked. An instructor-led course also carries its next session (null when it has none upcoming) and the learner's booking status: 0 not booked, 1 booked (with the booked session's date), 2 attended. Instructor-led courses are left out while the ilt feature flag is off. Returns 404 for a draft or Restricted path (LMS-154)
 * @summary Get the learner's progress through a learning path
 */
export const learningPathsGetProgress = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<LearningPathProgressDto>(
      {url: `/api/learning-paths/${id}/progress`, method: 'GET', signal
    },
      );
    }




export const getLearningPathsGetProgressQueryKey = (id: string,) => {
    return [
    `/api/learning-paths/${id}/progress`
    ] as const;
    }


export const getLearningPathsGetProgressQueryOptions = <TData = Awaited<ReturnType<typeof learningPathsGetProgress>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLearningPathsGetProgressQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof learningPathsGetProgress>>> = ({ signal }) => learningPathsGetProgress(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LearningPathsGetProgressQueryResult = NonNullable<Awaited<ReturnType<typeof learningPathsGetProgress>>>
export type LearningPathsGetProgressQueryError = void


export function useLearningPathsGetProgress<TData = Awaited<ReturnType<typeof learningPathsGetProgress>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningPathsGetProgress>>,
          TError,
          Awaited<ReturnType<typeof learningPathsGetProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningPathsGetProgress<TData = Awaited<ReturnType<typeof learningPathsGetProgress>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningPathsGetProgress>>,
          TError,
          Awaited<ReturnType<typeof learningPathsGetProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningPathsGetProgress<TData = Awaited<ReturnType<typeof learningPathsGetProgress>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the learner's progress through a learning path
 */

export function useLearningPathsGetProgress<TData = Awaited<ReturnType<typeof learningPathsGetProgress>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningPathsGetProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLearningPathsGetProgressQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Enrols the signed-in learner on the course if needed (as EnrollInCourse) and returns the enrolment. The learner must be enrolled on the path, and in an in-order path the course must not be locked (403 otherwise, with a message naming the course to complete first). Returns 404 for a draft or Restricted path (LMS-154) or a course the learner doesn't see in it
 * @summary Start a course from a learning path
 */
export const learningPathsStartCourse = (
    id: string,
    courseId: string,
 signal?: AbortSignal
) => {


      return apiClient<EnrollmentResponse>(
      {url: `/api/learning-paths/${id}/courses/${courseId}/start`, method: 'POST', signal
    },
      );
    }




export const getLearningPathsStartCourseMutationKey = () => ['learningPathsStartCourse'] as const;

export const getLearningPathsStartCourseMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartCourse>>, TError,LearningPathsStartCourseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartCourse>>, TError,LearningPathsStartCourseMutationVariables, TContext> => {

const mutationKey = getLearningPathsStartCourseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningPathsStartCourse>>, LearningPathsStartCourseMutationVariables> = (props) => {
          const {id,courseId} = props ?? {};

          return  learningPathsStartCourse(id,courseId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningPathsStartCourseMutationResult = NonNullable<Awaited<ReturnType<typeof learningPathsStartCourse>>>

    export type LearningPathsStartCourseMutationError = ProblemDetails | void
    export type LearningPathsStartCourseMutationVariables = {id: string;courseId: string}

    /**
 * @summary Start a course from a learning path
 */
export const useLearningPathsStartCourse = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningPathsStartCourse>>, TError,LearningPathsStartCourseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningPathsStartCourse>>,
        TError,
        LearningPathsStartCourseMutationVariables,
        TContext
      > => {
      return useMutation(getLearningPathsStartCourseMutationOptions(options), queryClient);
    }
